import React, { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import StaffCreateFormView from '../../../components/payroll/create/staff/StaffCreateFormView';
import PayrollStaffListView from '../../../components/payroll/report/staff/PayrollStaffListView';
import PayrollCreateFormView from '../../../components/payroll/create/payroll/PayrollCreateFormView';
import PayrollTableListView from '../../../components/payroll/create/payroll/PayrollTableListView';

const StaffPayrollCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.PayrollURL + 'payroll/staff/options/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    return (
        <Fragment>
            <Grid container spacing={1}>
                <Grid item xl={12} md={12} sm={12} xs={12} lg={12}>
                    <PayrollCreateFormView data={data} handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={12} md={12} sm={12} xs={12} lg={12}>
                    <PayrollTableListView  />
                </Grid>
            </Grid>

        </Fragment>
    )
}

export default StaffPayrollCreateListView